import { createAction } from 'redux-act';

import TimestampPayload from '../TimestampPayload';

export interface ReservationSettingUpdatedPayload extends TimestampPayload {
  placeUuid: string;
}
export const reservationSettingUpdated = createAction<ReservationSettingUpdatedPayload>('RESERVATION_SETTING_UPDATED');
